import { render, staticRenderFns } from "./CompanySignin.vue?vue&type=template&id=81228fc2&lang=html"
import script from "./CompanySignin.vue?vue&type=script&lang=js"
export * from "./CompanySignin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports